<template>
  <v-card>
    <v-card-title>
      Results: {{ eventName }}
      <v-spacer></v-spacer>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" :items="results" :loading="loading" :search="search" class="elevation-1" :rows-per-page-items="rowConfig">
      <v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
      <template slot="items" slot-scope="props">
        <tr>
          <td>{{ props.item.pos }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.gun }}</td>
          <td>{{ props.item.net }}</td>
          <td>{{ props.item.agecat }}</td>
          <td>{{ props.item.club }}</td>
          <td>{{ props.item.sal }}</td>
          <td>{{ props.item.jskid }}</td>
          <td>{{ props.item.netsec }}</td>
        </tr>
      </template>
      <v-alert slot="no-results" :value="true" color="error" icon="warning">
        Your search for "{{ search }}" found no results.
      </v-alert>
    </v-data-table>
  </v-card>
</template>

<script>
// should really be  lang="ts"
import fb from "@/firebaseConfig";
import router from "@/router";

export default {
  props: ["eventId"],
  data: () => ({
    search: "",
    loading: false,
    eventName: "",
    headers: [
      { align: "left", text: "Pos", value: "pos" },
      { text: "Name", value: "name" },
      { text: "Gun", value: "gun" },
      { text: "Net", value: "net" },
      { text: "Cat", value: "agecat" },
      { text: "Club", value: "club" },
      { text: "SAL", value: "sal" },
      { text: "JSK Id", value: "jskid" },
      { text: "Seconds", value: "netsec" }
    ],
    results: [],
    rowConfig: [
      10,
      25,
      50,
      { text: "$vuetify.dataIterator.rowsPerPageAll", value: -1 }
    ]
  }),
  created() {
    this.getResults();
  },
  methods: {
    getResults() {
      this.loading = true;
      //also dispatch event name .....
      fb.colEvents
        .doc(this.eventId)
        .get()
        .then(doc => {
          this.eventName = doc.data().name;
        })
        .catch(error => {
          console.log("error");
          console.log(error);
        });

      fb.colResults
        .where("eventid", "==", this.eventId)
        .orderBy("order")
        .get()
        .then(docResults => {
          docResults.forEach(doc => {
            this.results.push(...doc.data().results);
          });
        })
        .catch(error => {
          console.log("error");
          console.log(error);
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  components: {}
};
</script>
